export interface SelectedNetwork {
    networkId: string;
    networkName: string;
}

export interface ComplianceConnectNetwork {
    networkId: string;
    networkName: string;
    issuerName: string;
    totalGapCount: number;
    fillableGapCount: number;
    lastUpdatedDate: string;
    countyCount: number;
    networkType: string;
    adequacyIndex: number;
    percentPassBoth: number;
    percentPassOne: number;
    percentPassNone: number;
    percentPassByException: number;
    customProjectId: number;
    memberSetAlias: string;
    memberSetId: number;
    projectName: string;
    projectRunConfigurationId: number;
    showAdvancedComparison: boolean;
}

export interface GetRegulatorNetworksQuery {
    sortColumn?: string;
    sortDescending?: boolean;
    pageIndex?: number;
    pageSize?: number;
    networkNameSearch?: string;
    serviceAreaIds?: string[];
    specialtyGroupCodes?: string[];
}

export interface GetRegulatorNetworksResult {
    networks: ComplianceConnectNetwork[];
    totalCount: number;
}

export interface ComplianceConnectFilterOption {
    value: string;
    displayName: string;
    children?: ComplianceConnectFilterOption[];
}

export interface ComplianceConnectFilterOptions {
    serviceAreas: ComplianceConnectFilterOption[];
    specialties: ComplianceConnectFilterOption[];
}

export interface ComplianceConnectCountySpecialties {
    countyName: string;
    specialtyName: string;
    numberOfGaps: number;
    numberOfExceptions: number;
    numberOfIssuers: number;
}

export interface NetworkExceptionReview {
    networkId: string;
    networkName: string;
    total: number;
    approved: number;
    pending: number;
    denied: number;
}

export interface AggregateExceptionReview {
    total: number;
    approved: number;
    pending: number;
    denied: number;
}

export interface ExceptionReviewStatus {
    networks: NetworkExceptionReview[];
    aggregate: AggregateExceptionReview;
}

export enum TrendDirection {
    None = "none",
    Up = "up",
    Down = "down",
}

export interface IsolatedGapInstances {
    gapCount: number;
    issuerCount: number;
}

export interface UniqueGapFills {
    totalUniqueGapFills: number;
}

export interface IssuerComplianceComparison {
    adequacyIndex: number;
    approved: number;
    denied: number;
    deniedTrend: TrendDirection;
    exceptionOverlap: number;
    exceptions: number;
    exceptionsTrend: TrendDirection;
    gapOverlap: number;
    gaps: number;
    gapsTrend: TrendDirection;
    issuerId: string;
    issuerName: string;
    pending: number;
    percentPassAccessOnly: number;
    percentPassBoth: number;
    percentPassByException: number;
    percentPassNone: number;
    percentPassServicingOnly: number;
    rank: number;
    rankTrend: TrendDirection;
    topCountyGap: string;
    topSpecialtyGap: string;
}

export interface OpenGaps {
    fillableGaps: number;
    partiallyFillableGaps: number;
    unfillableGaps: number;
}

export interface ComplianceConnectNetworkFilterParams {
    networkNameSearch?: string;
    serviceAreaIds?: string[];
    specialtyGroupCodes?: string[];
}
